/* theme-product.js — product page only: image gallery and variant picker.
   Loaded by sections/main-product.liquid so the rest of the storefront does not
   pay for it. Depends on window.TechStore.strings / money_format from the layout. */
(function () {
  'use strict';

  if (window.__tsProductLoaded) return;
  window.__tsProductLoaded = true;

  var strings = (window.TechStore && window.TechStore.strings) || {};
  /* Neutral fallback on purpose: inventing '$' on a rupee store is worse than
     showing a bare number if the layout ever fails to publish money_format. */
  var moneyFormat = (window.TechStore && window.TechStore.money_format) || '{{amount}}';

  function formatMoney(cents) {
    cents = cents || 0;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var value = (number / 100.0).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', '');
        default: return fmt(cents, 2);
      }
    });
  }

  function thumb(url, w) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return url; }
  }

/* ---------- product gallery: instant swaps, preloaded, swipe ---------- */
  function initGallery(root) {
    if (root.dataset.tsGalInit) return;
    root.dataset.tsGalInit = '1';
    var main = root.querySelector('[data-ts-gal-main]');
    var dataEl = root.querySelector('[data-ts-gal-data]');
    if (!main || !dataEl) return;
    var imgs;
    try { imgs = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!imgs || imgs.length < 2) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ts-gal-thumb]'));
    var counter = root.querySelector('[data-ts-gal-count]');
    var idx = 0;

    /* Warm the browser cache so every swap is instant, not a fresh download.
       Runs after first paint so it never competes with the LCP image. */
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      imgs.forEach(function (o, n) {
        if (n === 0) return;
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = o.m;
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2000 });
    else setTimeout(warm, 800);

    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      var o = imgs[idx];
      /* drop srcset first so the browser can't re-pick a different candidate */
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = o.m;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + imgs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      /* preload the neighbours so arrow-spamming stays instant */
      [idx + 1, idx - 1].forEach(function (n) {
        var o2 = imgs[(n + imgs.length) % imgs.length];
        if (o2) { var p = new Image(); p.src = o2.m; }
      });
    }

    var prev = root.querySelector('[data-ts-gal-prev]');
    var next = root.querySelector('[data-ts-gal-next]');
    if (prev) prev.addEventListener('click', function () { warm(); show(idx - 1); });
    if (next) next.addEventListener('click', function () { warm(); show(idx + 1); });
    thumbs.forEach(function (t, n) {
      t.addEventListener('mouseenter', function () { var p = new Image(); p.src = imgs[n].m; });
      t.addEventListener('click', function () { warm(); show(n); });
    });

    var x0 = null;
    var stage = main.parentElement;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { warm(); show(dx < 0 ? idx + 1 : idx - 1); }
      x0 = null;
    }, { passive: true });
  }

/* ---------- product variant selector ---------- */
  function initProduct(root) {
    if (root.dataset.tsProductInit) return;
    root.dataset.tsProductInit = '1';
    var variants;
    var dataEl = root.querySelector('[data-ts-variants]');
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    if (!variants.length) return;

    var idInput = root.querySelector('[data-ts-variant-id]');
    var priceEl = root.querySelector('[data-ts-price]');
    var stockDot = root.querySelector('[data-ts-stock-dot]');
    var stockText = root.querySelector('[data-ts-stock-text]');
    var addBtn = root.querySelector('[data-ts-add-btn]');
    var addLabel = root.querySelector('[data-ts-add-label]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ts-option]'));
    if (!buttons.length) return;

    /* Price, compare-at and "% off" also appear in the repeat CTA and the sticky
       mobile bar, which live outside `root`. Collect them document-wide so a
       variant change cannot leave two different prices on screen. */
    var priceEls   = Array.prototype.slice.call(document.querySelectorAll('[data-ts-price]'));
    var compareEls = Array.prototype.slice.call(document.querySelectorAll('[data-ts-compare]'));
    var pctEls     = Array.prototype.slice.call(document.querySelectorAll('[data-ts-pct]'));
    var skuEls     = Array.prototype.slice.call(document.querySelectorAll('[data-ts-sku]'));
    var galMain    = document.querySelector('[data-ts-gal-main]');

    var current = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0];
    var selected = (current.options || []).slice();

    function paint() {
      buttons.forEach(function (b) {
        var pos = parseInt(b.getAttribute('data-ts-option'), 10) - 1;
        var on = selected[pos] === b.getAttribute('data-ts-value');
        b.style.borderColor = on ? 'var(--logo,#6d28d9)' : 'var(--border,#e6e6ea)';
        b.style.background = on ? 'color-mix(in srgb,var(--logo,#6d28d9) 7%,transparent)' : 'var(--bg,#fff)';
      });
    }

    function match() {
      return variants.filter(function (v) {
        return (v.options || []).every(function (o, i) { return o === selected[i]; });
      })[0];
    }

    function update() {
      var v = match();
      paint();
      var lbl = addLabel ? addLabel.dataset : {};
      var extraBtns = Array.prototype.slice.call(
        document.querySelectorAll('[data-ts-buynow], [data-ts-sticky-add]')
      );
      if (!v) {
        extraBtns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.style.opacity = '.45'; });
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.style.opacity = '.45';
          addBtn.style.cursor = 'not-allowed';
        }
        if (addLabel) addLabel.textContent = lbl.labelUnavailable || strings.unavailable;
        return;
      }
      idInput.value = v.id;

      priceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });

      var comp = v.compare_at_price || 0;
      var hasDiscount = comp > v.price;
      compareEls.forEach(function (el) {
        el.hidden = !hasDiscount;
        if (hasDiscount) el.textContent = formatMoney(comp);
      });
      pctEls.forEach(function (el) {
        el.hidden = !hasDiscount;
        if (!hasDiscount) return;
        var pct = Math.round(((comp - v.price) / comp) * 100);
        var tpl = el.getAttribute('data-suffix') || '[pct]% off';
        el.textContent = tpl.replace('[pct]', pct);
      });

      skuEls.forEach(function (el) { el.textContent = v.sku || ''; });

      if (galMain && v.image) {
        galMain.src = v.image;
        galMain.removeAttribute('srcset');
      }

      /* Keep the address bar on the selected variant so a shared or refreshed
         URL lands on the same one, without adding a history entry per click. */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      if (stockDot) stockDot.style.background = v.available ? '#1f8a5b' : '#b91c1c';
      if (stockText) {
        stockText.textContent = v.available
          ? (stockText.dataset.labelIn || strings.in_stock)
          : (stockText.dataset.labelOut || strings.sold_out);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (v.available) { addBtn.removeAttribute('aria-disabled'); }
        else { addBtn.setAttribute('aria-disabled', 'true'); }
        addBtn.style.opacity = v.available ? '1' : '.45';
        addBtn.style.cursor = v.available ? 'pointer' : 'not-allowed';
      }
      extraBtns.forEach(function (b) {
        b.disabled = !v.available;
        if (v.available) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
        b.style.opacity = v.available ? '1' : '.45';
        b.style.cursor = v.available ? 'pointer' : 'not-allowed';
      });
      if (addLabel) {
        addLabel.textContent = v.available
          ? (lbl.labelAdd || strings.add_to_cart)
          : (lbl.labelSoldOut || strings.sold_out);
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = parseInt(b.getAttribute('data-ts-option'), 10) - 1;
        selected[pos] = b.getAttribute('data-ts-value');
        update();
      });
    });
    paint();
  }

  /* Quantity stepper on the buy box. The input is a real <input name="quantity">
     so the form still works with JavaScript off. */
  function initQuantity(root) {
    var input = root.querySelector('[data-ts-qty]');
    if (!input) return;
    root.querySelectorAll('[data-ts-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-ts-qty-step'), 10) || 0;
        var next = (parseInt(input.value, 10) || 1) + step;
        input.value = next < 1 ? 1 : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    input.addEventListener('change', function () {
      var n = parseInt(input.value, 10);
      if (!n || n < 1) input.value = 1;
    });
  }

  /* Shopify's Product Recommendations API. The section re-renders itself server
     side, so the response is parsed and its inner markup swapped in — replacing
     the same-collection fallback that was rendered on the first pass. */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ts-recommendations]');
        if (!fresh) return;
        if (!fresh.querySelector('.ts-card')) return;
        el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-ts-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-ts-product]').forEach(initProduct);
    document.querySelectorAll('[data-ts-product]').forEach(initQuantity);
    document.querySelectorAll('[data-ts-recommendations]').forEach(initRecommendations);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
